/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useStorageDispatch, useUserThunkDispatch } from 'hooks';
import { userActions } from 'store/user';
import useAsyncFetch from 'hooks/async-fetch';
import UserCard from 'components/UserCard/UserCard';
import AppNotificationContainer from 'components/AppNotifications/AppNotificationContainer';
import { storageActions } from 'store/storage';
import HelpCard from 'components/HelpCard/HelpCard';
import TrialBanner from 'components/Trial/TrialBanner/TrialBanner';

import { useTranslation } from 'react-i18next';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import { Link } from 'react-router-dom';
import styles from './Header.module.scss';

const Header:React.FC = () => {
  const [t] = useTranslation();
  const user = useSelector((state: RootState) => state.user);
  const userThunkDispatch = useUserThunkDispatch();
  const storageDispatch = useStorageDispatch();
  const headerRef = useRef<HTMLDivElement>(null);

  useAsyncFetch({
    asyncFunc: async () => {
      if (!user.twoFaEnforcement?.blocking) {
        await userThunkDispatch(userActions.getRegions);
      }
    },
    immediate: true,
  });

  React.useEffect(() => {
    if (!user.twoFaEnforcement?.blocking) {
      storageDispatch(storageActions.getHasAccess());
    }
  }, []);

  const handleScrollBody = () => {
    const scrollValue = window.scrollY;
    if (scrollValue > 20 && headerRef.current) {
      headerRef.current.classList.add(styles.scrolled);
    } else if (headerRef.current) {
      headerRef.current.classList.remove(styles.scrolled);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScrollBody);
    return () => {
      window.removeEventListener('scroll', handleScrollBody);
    };
  }, []);

  return (
    <header ref={headerRef} className={styles.header}>
      <div className={styles.breadcrumbs} />
      <Breadcrumbs />
      <div className={styles.actions}>
        <TrialBanner className={styles.trialBanner} />
        <HelpCard className={styles.helpCard} />
        <AppNotificationContainer className={styles.notificationContainer} />
        <UserCard user={user} />
      </div>
    </header>
  );
};

export default Header;
